import { useLang } from "@/context/LangContext";
import CreatorsStrip from "@/sections/CreatorsStrip";
import Community from "@/sections/Community";
import { Reveal } from "@/components/Reveal";
import Seo, { breadcrumbLd } from "@/components/Seo";
import { PAGE_SEO } from "@/lib/seo";

const CreatorsPage = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-creators">
      <Seo {...PAGE_SEO.creators} jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Creators", path: "/creators" }])]} />
      <section className="bg-skywash border-b border-ink py-14 md:py-20">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8">
          <Reveal>
            <p className="kicker text-ink/60">{t.creatorsKicker}</p>
            <h1 className="display uppercase text-6xl md:text-8xl leading-[0.84] mt-2 text-brand">{t.creatorsTitle}</h1>
            <p className="mt-4 max-w-xl text-lg font-medium text-ink/70">{t.creatorsSub}</p>
          </Reveal>
        </div>
      </section>
      <CreatorsStrip full />
      <Community />
    </div>
  );
};

export default CreatorsPage;
